<template>
  <el-row class="auxcard el-row">
    <iframe class="auxmode-iframe" src="https://dashboard.auxmode.com/AuxMode_Dashboard/dashboard-clients.jsp" frameborder="0" scrolling="yes"></iframe>
  </el-row>
</template>

<script>

export default {
  data() {
    return {
      choose: 1,
    }
  },
}
</script>

<style lang="scss" scoped>
  .auxmode-iframe {
    position: absolute;
    top: 0;
    left: 0px;
    width: 1850px;
    height: 900px;
    border: none;
    margin-left: -280px;
    margin-top: -124px;
  }
  .auxcard {
    width: 100%;
    max-width: 1850px;
  }
  .bell_img{
    margin-right: 10px;
  }
  .auxmode_img{
    z-index:950;
    position: absolute;
    right: 0;
    margin-right: 55px;
  }
</style>